import { List } from "antd";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper-bundle.css";

export const HeroBanner = styled("div")({
  position: "relative",
  width: "100%",
  maxHeight: "500px",
  overflow: "hidden",
});

export const HeroImage = styled("img")({
  width: "100%",
  height: "auto",
  display: "block",
  objectFit: "contain",
});

export const CategoryWrapper = styled("div")(({ theme }) => ({
  padding: "40px 20px",
  maxWidth: theme.screenLGMax,
  margin: "0 auto",
}));

export const Title = styled("h2")({
  textAlign: "center",
  fontSize: "28px",
  marginBottom: "40px",
  color: "#333",
});

export const CarouselWrapper = styled("div")({
  marginBottom: "40px",
});

export const Carousel = styled(Swiper)({
  padding: 16,
  margin: -16,
});

export const CarouselSlide = styled(SwiperSlide)({
  width: 320,
});

export const HeroOverlay = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  flexDirection: "row",
  textAlign: "left",
  padding: "0 40px",
});

export const HeroTitle = styled("h1")({
  fontSize: "50px",
  lineHeight: 1.3,
  fontWeight: 700,
  maxWidth: "400px",
  color: "white",
});

export const SearchBox = styled("div")({
  display: "flex",
  alignItems: "center",
  background: "white",
  borderRadius: "30px",
  padding: "6px 12px",
  minWidth: "450px",
  gap: "8px",
});

export const SearchInput = styled("input")({
  border: "none",
  outline: "none",
  padding: "10px 8px",
  fontSize: "16px",
  borderRadius: "30px",
  width: "100%",
});

export const SearchIcon = styled("span")(({ theme }) => ({
  color: theme.colorPrimary,
  fontSize: "20px",
}));

export const SectionTitle = styled("h2")({
  textAlign: "center",
  fontSize: "30px",
  margin: "40px 0 40px",
  color: "#333",
});

export const BusinessesList: typeof List = styled(List)(({ theme }) => ({
  "& .ant-list-items": {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing * 4,
  },
}));
